var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import IconContainer from "./IconContainer";
const ErrorCircleIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (React.createElement(IconContainer, Object.assign({ className: classNames("gerudo-icon-error-circle", size, className) }, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.0", viewBox: "0 0 128 128", role: "img", "aria-label": title },
            React.createElement("title", null, title),
            React.createElement("path", { fill: "currentColor", d: "M64,0A64,64,0,1,1,0,64,64.188,64.188,0,0,1,64,0Z", role: "presentation" }),
            React.createElement("path", { fill: "#fff", d: "M64,23.5A10.956,10.956,0,0,0,53,34.384c0,3.825,4.215,28.67,6.265,37.74A1.78,1.78,0,0,0,61,73.5h6a1.773,1.773,0,0,0,1.737-1.376C70.785,63.058,75,38.209,75,34.384A10.954,10.954,0,0,0,64,23.5Z", role: "presentation" }),
            React.createElement("circle", { fill: "#fff", cx: "64", cy: "93.5", r: "11", role: "presentation" }))));
};
ErrorCircleIcon.defaultProps = {
    title: "Error",
};
export { ErrorCircleIcon };
export default ErrorCircleIcon;
//# sourceMappingURL=ErrorCircle.js.map